module.exports = __webpack_public_path__ + "assets/img/Listing.7aa8e921.svg";